var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsTraining = function SvgFormsTraining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.007 9.872a1.58 1.58 0 00-1.46.061 1.405 1.405 0 00-.714 1.208v6.885a1.408 1.408 0 00.713 1.207 1.579 1.579 0 001.461.061l6.461-3.05a1.814 1.814 0 000-3.322l-6.46-3.05zM31.944 41.667H18.056l1.388-8.334h11.112l1.388 8.334zM13.889 41.667H36.11M4.167 26.389h41.666",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 2.778h41.666v30.555H4.167V2.778z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsTraining;